export default __webpack_public_path__ + "static/media/jardins.91395c88.PNG";